// 9fbef606107a605d69c0edbcd8029e5d
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { setLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import { formatPhoneNumber, getDateObject } from '@tcp/core/src/utils/utils';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import toTimeString from '@tcp/core/src/utils/formatTime';
import { parseDate } from '@tcp/core/src/utils/parseDate';
import { getDirections } from '@tcp/core/src/utils';
import styles from '../styles/PickUpSummary.style';
import {
  getLabelFromCopyOrFromTranslation,
  getLabelWithDefaultValue,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  ACCOUNT_ORDERS_LABEL,
  OrderDetailLabels,
  lblOrderOpenToday,
  lblOrdersGetDirections,
  lblOrdersPhone,
  lblOrdersPickupPerson,
} from '../../../container/OrderDetails.labels';
import { CUSTOMER_HELP_ROUTES } from '../../../../CustomerHelp/CustomerHelp.constants';

/**
 * This function component use for return the PickUpSummary
 * can be passed in the component.
 * @param ordersLabels - ordersLabels object used for showing Orders Labels
 */

const PickUpSummary = ({
  className,
  pickUpStore,
  isAddAltPickupPersonEnabled,
  altPickupPersonLimit,
  altPickupPersonInvaildOrderStatus,
  orderDetailsData,
  isCSHEnabled,
}) => {
  /**
   * @function return  Used to render the JSX of the component
   * @param    {[Void]} function does not accept anything.
   * @return   {[Object]} JSX of the component
   */

  const { basicInfo, pickUpPrimary, pickUpAlternative, hours, altPickUpPersons } = pickUpStore;
  const { address, phone } = basicInfo;
  const {
    orderStatus,
    orderNumber,
    emailAddress: orderEmail,
    encryptedEmailAddress,
  } = orderDetailsData || {};
  useEffect(() => {
    setLocalStorage({
      key: 'PICKUP_DATA',
      value: JSON.stringify({ ...pickUpStore, orderEmail, encryptedEmailAddress }),
    });
  }, []);
  let today;
  if (hours) {
    const now = getDateObject();
    today = hours.regularHours.find((day) => {
      const openingHour = parseDate(day.openIntervals[0].fromHour);
      return now.getDay() === openingHour.getDay();
    });
  }
  const invalidPickupStatus = altPickupPersonInvaildOrderStatus
    ?.split(',')
    ?.map((str) => str?.toLowerCase());
  const hideLink = invalidPickupStatus?.includes(orderStatus);
  const orderLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_ORDERS_LABEL, OrderDetailLabels);
  let isFromTrackOrder;
  if (typeof window !== 'undefined') {
    isFromTrackOrder = window?.location?.href?.split('/')?.includes('track-order');
  }
  return (
    <BodyCopy component="div" className={className}>
      <BodyCopy className="capitalize" fontSize="fs14" fontWeight="black" fontFamily="secondary">
        {basicInfo.storeName}
      </BodyCopy>

      <BodyCopy className="capitalize" fontSize="fs14" fontWeight="black" fontFamily="secondary">
        {address.addressLine1}
      </BodyCopy>

      <BodyCopy className="capitalize" fontSize="fs14" fontWeight="black" fontFamily="secondary">
        {`${address.city}, ${address.state}, ${address.zipCode}`}
      </BodyCopy>
      <BodyCopy className="margin-wrapper" component="div">
        {today && (
          <BodyCopy fontSize="fs14" fontFamily="secondary">
            {`${getLabelWithDefaultValue(orderLabels, lblOrderOpenToday)}: ${toTimeString(
              parseDate(today.openIntervals[0].fromHour)
            )} - ${toTimeString(parseDate(today.openIntervals[0].toHour))}`}
          </BodyCopy>
        )}
        <BodyCopy class="phone-pickup" fontSize="fs14" fontFamily="secondary">
          {`${getLabelWithDefaultValue(orderLabels, lblOrdersPhone)}: ${formatPhoneNumber(phone)}`}
        </BodyCopy>
      </BodyCopy>
      <Anchor
        fontSizeVariation="large"
        underline
        noLink
        anchorVariation="primary"
        fontFamily="secondary"
        href="#"
        onClick={() => getDirections(address)}
        className="margin-wrapper"
      >
        {getLabelWithDefaultValue(orderLabels, lblOrdersGetDirections)}
      </Anchor>
      <div className="margin-wrapper pickup-heading">
        <BodyCopy fontSize="fs14" fontWeight="extrabold" fontFamily="secondary">
          {getLabelWithDefaultValue(orderLabels, lblOrdersPickupPerson)}
        </BodyCopy>
        {!hideLink &&
          isCSHEnabled &&
          isAddAltPickupPersonEnabled &&
          altPickUpPersons?.length < altPickupPersonLimit && (
            <Anchor
              fontSizeVariation="large"
              underline
              to={`${CUSTOMER_HELP_ROUTES.ADD_PICKUP_PERSON.to}&orderId=${orderNumber}`}
              asPath={
                isFromTrackOrder
                  ? `${CUSTOMER_HELP_ROUTES.ADD_PICKUP_PERSON.asPath}/${orderNumber}?track-order`
                  : `${CUSTOMER_HELP_ROUTES.ADD_PICKUP_PERSON.asPath}/${orderNumber}`
              }
              anchorVariation="primary"
              fontFamily="secondary"
              fontSize="fs14"
              className="elem-ml-SM add-pickup-link"
            >
              {'Add pickup person'}
            </Anchor>
          )}
      </div>

      <BodyCopy fontSize="fs14" fontFamily="secondary">
        {`${pickUpPrimary.firstName} ${pickUpPrimary.lastName}`}
      </BodyCopy>

      {isAddAltPickupPersonEnabled
        ? altPickUpPersons?.length > 0 &&
          altPickUpPersons.map((data) => {
            return (
              <BodyCopy fontSize="fs14" fontFamily="secondary">
                {`${data?.fullName}`}
              </BodyCopy>
            );
          })
        : pickUpAlternative && (
            <BodyCopy fontSize="fs14" fontFamily="secondary">
              {`${pickUpAlternative.firstName} ${pickUpAlternative.lastName}`}
            </BodyCopy>
          )}
    </BodyCopy>
  );
};
PickUpSummary.propTypes = {
  className: PropTypes.string,
  pickUpStore: PropTypes.shape({}),
};

PickUpSummary.defaultProps = {
  className: '',
  pickUpStore: {},
};

export default withStyles(PickUpSummary, styles);
export { PickUpSummary as PickUpSummaryVanilla };
